import { render } from "./EletromecanicaPage.vue?vue&type=template&id=490b9db4&scoped=true"
import script from "./EletromecanicaPage.vue?vue&type=script&lang=js"
export * from "./EletromecanicaPage.vue?vue&type=script&lang=js"

import "./EletromecanicaPage.vue?vue&type=style&index=0&id=490b9db4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490b9db4"]])

export default __exports__